export default "__VITE_ASSET__YWTYCCF$__"